import { render, staticRenderFns } from "./loan-collateral.vue?vue&type=template&id=546f851c&"
import script from "./loan-collateral.vue?vue&type=script&lang=js&"
export * from "./loan-collateral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports